import { render, staticRenderFns } from "./MyQR.vue?vue&type=template&id=17efa7f4&scoped=true"
import script from "./MyQR.vue?vue&type=script&lang=js"
export * from "./MyQR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17efa7f4",
  null
  
)

export default component.exports